<article class="card transparent-card search-card">
  <span class="card-body">
    <h3 class="mb-2 card-title"><a [routerLink]="'/' + content_type + '/' + ContentNode.alias">{{ ContentNode.name }}</a></h3>
    <div [innerHTML]="ContentNode.definition"></div>
  </span>
</article>
